module.exports = __webpack_public_path__ + "static/media/affiliates-icon-active.f8d28403.svg";